import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";

const ContractTable = ({ primary, secondary, data }) => {
  return (
    <TableContainer
      sx={{
        borderRadius: "0px",
        border: "2px solid #c3c1c1",
        borderBottom: "none",
        "& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root": {
          backgroundColor: "#ededed",
          color: "secondary.dark",
          fontWeight: 600,
          fontSize: "1rem",
        },
        "& .MuiTableBody-root .MuiTableRow-root .table-cell": {
          padding: "6px 10px",
          borderBottom: "2px solid #c3c1c1",
          // fontSize:"0.875rem",
          fontWeight:500
        },
        // "& .MuiTableBody-root .MuiTableRow-root .table-cell:last-child": {
        //   padding: "6px 10px",
        //   borderBottom: "0px solid #c3c1c1",
        // },
      }}
      // sx={{ maxWidth: "900px", margin: "auto" }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ borderRight: "2px solid #c3c1c1", width: "50%" }}>
              {primary}
            </TableCell>
            <TableCell sx={{ width: "50%", textAlign: "center" }}>
              {secondary}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data}
          {/* {data?.map((row, index) => (
            <TableRow key={index}>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                {row.feature}
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                {row.details}
              </td>
            </TableRow>
          ))} */}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ContractTable;
